import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const ArrowUpRightIcon =  ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}>
    <path
      fill={fill}
className={`dark:${
        isActive
          ? "fill-primary"
          : "fill-caption group-hover:dark:fill-primary"
      }`}
      fillRule="evenodd"
      d="M18.365 4.636a1 1 0 0 1 1 1v9.9a1 1 0 1 1-2 0V8.05L6.344 19.071a1 1 0 1 1-1.414-1.414l11.02-11.02H8.465a1 1 0 1 1 0-2h9.9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ArrowUpRightIcon;
